import React from 'react';

const Notification = () => (
    <section className="section">
        <div className="columns is-centered">
            <div className="column is-one-third">
                <div className="notification is-info">
                    Još uvek nema nikakve statistike. Morate uraditi barem jedan zadatak da bi se statistika pojavila.
                </div>
            </div>
        </div>
        <div className="has-text-centered">
            <span className="icon is-large has-text-info">
                <i className="fas fa-3x fa-chart-bar" aria-hidden="true"></i>
            </span>
        </div>
    </section>
)

export default Notification;
